<template>
  <div class="text-center pa-4">
    <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
      scrim="rgba(0,0,0,.65)"
    >
      <v-card rounded="xl" class="pa-4 cool-card team-modal" elevation="12">
        <div class="card-title-pro mb-4">{{ $t("editar_equipos") }}</div>

        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model.trim="teamName"
              :label="$t('nombre_equipo')"
              density="comfortable"
              hide-details
              prepend-inner-icon="mdi-account-group"
            />
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="bossId"
              :items="users"
              item-title="label"
              item-value="id"
              :label="$t('lider2')"
              density="comfortable"
              hide-details
              :loading="loadingUsers"
              :disabled="loadingUsers || users.length === 0"
              clearable
              prepend-inner-icon="mdi-account-tie"
            />
          </v-col>
        </v-row>

        <div class="d-flex justify-end ga-2 mt-4">
          <v-btn
            color="success"
            variant="elevated"
            :disabled="!teamName"
            :loading="saving"
            @click="saveTeam"
          >
            {{ $t("guardar") }}
          </v-btn>

          <v-btn variant="text" @click="closeDialog">{{ $t("cerrar2") }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { swal } from "@/utils/swal";
import { useSettingsStore } from "@/stores/settings";
import { updateTeam } from "@/api/equipos";

export default {
  name: "EditarEquipos",
  props: {
    modelValue: { type: Boolean, default: false },
    team: { type: Object, default: null },
    users: { type: Array, default: () => [] },
    loadingUsers: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "roles-updated"],
  data() {
    return {
      teamName: "",
      bossId: null,
      saving: false,
    };
  },
  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    dialog(val) {
      if (val) this.fillForm();
    },
    team: {
      deep: true,
      handler() {
        if (this.dialog) this.fillForm();
      },
    },
    users() {
      if (this.dialog) this.fillForm();
    },
  },
  methods: {
    fillForm() {
      const t = this.team;
      if (!t) {
        this.teamName = "";
        this.bossId = null;
        return;
      }

      this.teamName = (t.teamname || "").toString();
      const leaderId = t?.boss?.id ?? null;
      this.bossId =
        leaderId !== null && leaderId !== "" ? Number(leaderId) : null;
    },
    closeDialog() {
      this.dialog = false;
    },
    async saveTeam() {
      try {
        const teamId = this.team?.id;
        if (!teamId) return;

        this.saving = true;

        await updateTeam(teamId, {
          teamname: this.teamName,
          boss_id: this.bossId,
        });

        this.dialog = false;
        this.$emit("roles-updated");

        await swal({
          icon: "success",
          title: this.$t("team_updated"),
          text: this.$t("team_saved_changes"),
          timer: 2200,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (e) {
        const msg =
          e?.response?.data?.detail ||
          e?.response?.data?.error ||
          this.$t("team_update_error");
        this.dialog = false;
        await swal({
          icon: "error",
          title: "Error",
          text: msg,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
